<script setup>
import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "vue-i18n";
import ACL from "./ACL.vue";

defineProps({
  form: {
    required: false,
  },
  knocOptionsForm: {
    required: false,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="space-y-6 rounded-lg border p-6 shadow-sm">
    <h3 class="scroll-m-20 text-2xl font-semibold tracking-tight">
      {{ t("pages.wizard.steps.settings.preview.heading") }}
    </h3>

    <div class="space-y-2">
      <p class="text-sm text-muted-foreground">
        {{ t("pages.wizard.steps.settings.preview.description") }}
      </p>
      <ACL
        mode="card"
        :acl="{
          ACLID: '00000000-0000-0000-0000-000000000000',
          Description: form?.Description || t('pages.wizard.steps.settings.preview.defaultDescription'),
          URL: form?.URL,
          Icon: form?.Icon,
          Status: 4,
          ClickToGrant: knocOptionsForm?.ClickToGrant,
        }"
      />
    </div>

    <div
      v-if="knocOptionsForm?.IpExclusions?.RestrictionType && knocOptionsForm.IpExclusions.RestrictionType !== 'none'"
      class="space-y-2"
    >
      <p class="text-sm text-muted-foreground">
        {{ t("pages.wizard.steps.settings.preview.descriptionOutsideIPRange") }}
      </p>
      <ACL
        mode="card"
        :acl="{
          ACLID: '00000000-0000-0000-0000-000000000000',
          Description: form?.Description || t('pages.wizard.steps.settings.preview.defaultDescription'),
          URL: form?.URL,
          Icon: form?.Icon,
          Status: 4,
          ClickToGrant: knocOptionsForm?.ClickToGrant,
          DisableForUser: true,
        }"
      />
    </div>

    <div v-if="knocOptionsForm?.HideFromUsers" class="text-sm text-muted-foreground">
      <span>*{{ t("pages.wizard.steps.settings.preview.hideFromUsersInformational") }}</span>
    </div>

    <div v-if="knocOptionsForm?.AutoBrowseUsers" class="flex items-center space-x-2 text-sm">
      <ExclamationCircleIcon class="h-7 w-7 flex-shrink-0" />
      <span>{{ t("pages.wizard.steps.settings.preview.autoBrowseWarning") }}</span>
    </div>

    <div
      v-if="knocOptionsForm?.AutoBrowseUsers && !Boolean(form?.URL)"
      class="flex items-center space-x-2 text-sm text-primary"
    >
      <ExclamationCircleIcon class="h-7 w-7 flex-shrink-0" />
      <span>{{ t("pages.wizard.steps.settings.preview.autoBrowseWarningNoUrl") }}</span>
    </div>
  </div>
</template>
